import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { config } from './components/pages/config';
import HomePage from './components/pages/Home';
import AboutIndex from './components/pages/About';
import ServiceIndex from './components/pages/Services';
import ContactIndex from './components/pages/Contact';
import TestimonialIndex from './components/pages/Testimonials';
import ServiceDetails from './components/pages/Services/ServiceDetails';
import NewsList from './components/pages/News/NewsList';
import NewsDetails from './components/pages/News/NewsDetails';
import NotFound from './components/common/NotFound';
import CaseStudy from './components/pages/CaseStudy/CaseStudy';
import CaseDetail from './components/pages/CaseStudy/CaseDetail';
import Privacy from './components/pages/Company-Pages/Privacy';
import Terms from './components/pages/Company-Pages/Terms-Condiitons';

const AllRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about-us" element={<AboutIndex />} />
      <Route path="/services" element={<ServiceIndex />} />
      <Route path="/service/:slug" element={<ServiceDetails />} />
      <Route path="/contact-us" element={<ContactIndex />} />
      {/* <Route path='/testimonials' element={<TestimonialIndex />} /> */}
      <Route path="/case-studies" element={<CaseStudy />} />
      <Route path="/case-study/:slug" element={<CaseDetail />} />
      <Route path="/news-and-update" element={<NewsList />} />
      <Route path="/news/:slug" element={<NewsDetails />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/terms-conditions" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AllRoutes;
